import { Loader2, Users } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import { Select } from '@/components/ui/select'
import { useRoleOptions } from '@/features/access/api'
import { apiErrorMessage } from '@/i18n'
import { useSaveRoleLayout } from '../api'
import type { WidgetConfig } from '../types'

/** Düzenleyicideki düzeni seçilen rolün varsayılan anasayfası olarak kaydeder (dashboard:layout:manage). */
export function RoleDefaultControl({ widgets }: { widgets: WidgetConfig[] }) {
  const { t } = useTranslation()
  const roles = useRoleOptions()
  const save = useSaveRoleLayout()
  const [roleId, setRoleId] = useState('')
  return (
    <span className="inline-flex items-center gap-1.5">
      <Select size="sm" value={roleId} onChange={setRoleId} placeholder={t('dashboard.edit.roleDefaultPick')} options={(roles.data ?? []).map((r) => ({ value: r.id, label: r.name }))} aria-label={t('dashboard.edit.roleDefaultPick')} />
      <Button
        variant="outline"
        disabled={!roleId || save.isPending}
        title={t('dashboard.edit.roleDefaultHint')}
        onClick={() =>
          save.mutate(
            { roleId, widgets },
            { onSuccess: () => toast.success(t('dashboard.edit.roleDefaultSaved')), onError: (e) => toast.error(apiErrorMessage(e)) },
          )
        }
      >
        {save.isPending ? <Loader2 className="animate-spin" /> : <Users />}
        {t('dashboard.edit.roleDefault')}
      </Button>
    </span>
  )
}
